module.exports = __webpack_public_path__ + "static/media/project_status_white.2d154299.svg";